<template>
  <div class="bidder-page">
    <!-- 搜索区域 -->
    <div class="search-section">
        <el-form :model="searchForm" :inline="true" class="search-form">
          <el-form-item>
            <el-input v-model="searchForm.projectName" placeholder="招标项目或标段名称" clearable
              style="width: 300px;"></el-input>
          </el-form-item>
          <el-form-item>
            <el-select v-model="searchForm.bidStatus" placeholder="开标状态" clearable style="width: 150px;">
              <el-option label="全部" value=""></el-option>
              <el-option label="未开标" value="0"></el-option>
              <el-option label="已开标" value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-select v-model="searchForm.winStatus" placeholder="是否中标" clearable style="width: 150px;">
              <el-option label="全部" value=""></el-option>
              <el-option label="未中标" value="0"></el-option>
              <el-option label="已中标" value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="handleSearch">
              查询
            </el-button>
          </el-form-item>
          <el-form-item>
            <el-button icon="el-icon-refresh" @click="handleReset">
              重置
            </el-button>
          </el-form-item>
          <el-form-item>
            <!-- <el-button type="success" icon="el-icon-document" @click="handleContractSeal">
              合同签章
            </el-button> -->
          </el-form-item>
        </el-form>
      </div>

    <!-- 表格区域 -->
    <div class="table-section">
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column label="序号" width="80" align="center">
          <template slot-scope="scope">
            {{ (pageNum - 1) * pageSize + scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column prop="projectName" label="招标项目名称" min-width="200">
          <template slot-scope="scope">
            <div>
              <el-link type="primary" :underline="false">{{ scope.row.projectName }}</el-link>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="sectionCode" label="标段编号" min-width="200"></el-table-column>
        <el-table-column prop="sectionName" label="标段名称" min-width="200"></el-table-column>
        <el-table-column prop="biddingUnit" label="招标单位" min-width="200"></el-table-column>
        <el-table-column prop="agencyName" label="代理机构" min-width="200"></el-table-column>
        <el-table-column prop="platformServiceCharge" label="技术服务费" min-width="120" align="center">
          <template slot-scope="scope">
            <span>{{ formatServiceCharge(scope.row.platformServiceCharge) }}</span>
            <i class="el-icon-question" style="margin-left: 4px; color: #999; font-size: 12px;"></i>
          </template>
        </el-table-column>
        <el-table-column label="操作" min-width="120">
          <template slot-scope="scope">
            <el-link type="primary" :underline="false" @click="handleEnterProcess(scope.row)">进入流程</el-link>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="pagination-section">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNum"
          :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { getPurchasedProjectList } from '@/api/tenderNotice/api'
import { checkIsPublish } from '@/api/abnormalTermination/api'
export default {
  name: 'MyPurchaseProjects',
  data() {
    return {
      searchForm: {
        projectName: '',
        bidStatus: '',
        winStatus: ''
      },
      pageNum: 1,
      pageSize: 10,
      total: 0,
      tableData: []
    }
  },
  mounted() {
    this.getPurchasedProjectList()
  },
  methods: {
    // 获取已购标项目列表
    getPurchasedProjectList() {
      getPurchasedProjectList({
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        keyword: this.searchForm.projectName,
        bidStatus: this.searchForm.bidStatus,
        winStatus: this.searchForm.winStatus
      }).then(res => {
        if (res && res.data) {
          this.tableData = res.data.records || []
          this.total = res.data.total || 0
        } else {
          this.tableData = []
          this.total = 0
        }
      }).catch(error => {
        console.error('获取已购标项目列表失败:', error)
        this.$message.error('获取数据失败')
      })
    },
    // 格式化技术服务费显示
    formatServiceCharge(value) {
      if (value === null || value === undefined) {
        return '否'
      }
      // 如果是数字且大于0，显示"是"，否则显示"否"
      if (typeof value === 'number') {
        return value > 0 ? '是' : '否'
      }
      return value
    },
    handleEnterProcess(row) {
      checkIsPublish({
        bidSectionCode: row.sectionCode
      }).then(res => {
        if (res.code == 200) {
          if (res.data == false) {
            localStorage.setItem('sectionCode', row.sectionCode)
            this.$router.push({ path: '/bidderHome/bidderFlow', query: { sectionCode: row.sectionCode } })
          }else {
            this.$message.error('该项目不允许进入')
          }
        } else {
          this.$message.error(res.msg)
        }
      }).catch(error => {
        this.$message.error('进入流程失败')
      })
    },
    handleSearch() {
      // 处理搜索逻辑
      this.pageNum = 1
      this.getPurchasedProjectList()
    },
    handleReset() {
      // 处理重置逻辑
      this.searchForm = {
        projectName: '',
        bidStatus: '',
        winStatus: ''
      }
      this.pageNum = 1
      this.getPurchasedProjectList()
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.pageNum = 1
      this.getPurchasedProjectList()
    },
    handleCurrentChange(val) {
      this.pageNum = val
      this.getPurchasedProjectList()
    }
  }
}
</script>

<style lang="less" scoped>
@import '@/styles/minimal-gray-theme.less';

.bidder-page {
  .apply-minimal-gray-theme();
}
</style>
